<template>
    <div>
        <title-component></title-component>
        <funeral-menu-component></funeral-menu-component>
        <router-view></router-view>
    </div>
</template>

<script>
    import TitleComponent from './shared/TitleComponent'
    import FuneralMenuComponent from './funeral/FuneralMenuComponent'

    export default {
        name: 'MyFuneral',
        components: {
            'title-component': TitleComponent,
            'funeral-menu-component': FuneralMenuComponent
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/MyFuneralComponent.vue